// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect } from 'react';
import { window, document } from '../../../env/browser';
import { createAsyncScriptNode } from '../../../utils/dom';

export function BeamerWidget(props) {
  useEffect(() => {
    if (!window.beamer_config) {
      const {
        email,
        firstName,
        lastName,
        locale,
        productId,
        segments,
        targetElementId,
        userId,
        customAttributes,
      } = props;

      window.beamer_config = {
        post_request: true,
        filter: segments.join(';'),
        language: locale,
        bottom: 10,
        right: 10,
        product_id: productId,
        selector: `#${targetElementId}`,
        user_email: email,
        user_firstname: firstName,
        user_id: userId,
        user_lastname: lastName,
        ...customAttributes,
      };

      document.head.appendChild(
        createAsyncScriptNode({
          src: `https://app.getbeamer.com/js/beamer-embed.js`,
          defer: 'defer',
        })
      );
    }
  }, [props]);

  return null;
}
